/** Полный уход браузера на другой адрес (не маршрут SPA): выход из браузерной
 *  сессии Zitadel. Отдельной функцией — чтобы тесты могли её подменить:
 *  `window.location` в тестовом DOM не переопределить. */
export function leaveTo(url: string): void {
  window.location.assign(url);
}
